import classNames from 'classnames';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  onClosed: () => void;
  className?: string;
  bottom?: ReactNode;
}
export function BlotterPanelHeaderLayout({ children, onClosed, className, bottom }: Props) {
  return (
    <div
      className={classNames(className, 'card-header d-flex flex-wrap justify-content-between px-4 py-3')}
      data-e2e="side-panel-header"
    >
      <div className="d-flex w-100">
        {children}
        <button
          type="button"
          className="btn btn-icon btn-flat-secondary"
          aria-label="Close"
          onClick={onClosed}
          data-e2e="blotter-panel-close"
        >
          <i className="icon">clear</i>
        </button>
      </div>
      {bottom && <div className="d-flex w-100">{bottom}</div>}
    </div>
  );
}
